/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 8/3/2021
 * @Example
 */


import Api from '../../../services/api';
import { cancel, take, takeLatest } from "redux-saga/effects";
import { types } from "./W09F2001_actions";
import { delay } from "redux-saga";

export default function W09F2001Sagas() {
    return [
        watchGetDataGridHR(),
        watchGetCbReport(),
        watchGetCbTran(),
    ];
}

export function* getDataGridHR(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w09f2001/load-history-employee', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get info error', e);
    }
}
export function* watchGetDataGridHR() {
    while (true) {
        const watcher = yield takeLatest(types.W09F2001_GET_GRID_HR, getDataGridHR);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* getCbReport(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w09f2001/load-cbo-report', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get info error', e);
    }
}
export function* watchGetCbReport() {
    while (true) {
        const watcher = yield takeLatest(types.W09F2001_GET_CB_REPORT, getCbReport);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* getCbTran(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w09f2001/load-cbo-tran', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get info error', e);
    }
}
export function* watchGetCbTran() {
    while (true) {
        const watcher = yield takeLatest(types.W09F2001_GET_CB_TRAN, getCbTran);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}